import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Input from '@material-ui/core/Input';
import TextField from "@material-ui/core/TextField";
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Button from "@material-ui/core/Button";
import { NotificationManager } from "react-notifications";
import IntlMessages, { IntlGetText } from "util/IntlMessages";
import CircularProgress from "@material-ui/core/CircularProgress";
import { hideMessage, showAuthLoader, userSignIn } from "actions/Auth";
import { useTheme } from "@material-ui/core/styles";
import { MdVisibility, MdVisibilityOff } from "react-icons/md";

const SignIn = (props) => {
  const theme = useTheme();
  const msgLoginInvalid = IntlGetText("login.loginInvalid");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const { loader, alertMessage, showMessage, authUser } = useSelector(
    ({ auth }) => auth
  );

  useEffect(() => {
    if (showMessage) {
      setTimeout(() => {
        dispatch(hideMessage());
      }, 100);
    }
    if (authUser !== null) {
      props.history.push("/");
    }
  }, [showMessage, authUser, props.history, dispatch]);

  return (
    <div className="login-page animated slideInUpTiny animation-duration-3">
      <div className="login-floating-microsoft">
        <img src="/media\login\microsoft.png" alt="Microsoft Partner" />
      </div>
      <div className="login-card">
        <div className="login-top-image">
          <img src="/media/login/iconoIntelcare.png" alt="Login top" />
        </div>
        <div className="login-form">
          <form>
            <fieldset>
              <TextField
                placeholder="Usuario"
                fullWidth
                variant="standard"
                InputLabelProps={{ shrink: false }}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <Input
                type={showPassword ? "text" : "password"}
                fullWidth
                placeholder="Contraseña"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                      size="small"
                    >
                      {showPassword ? <MdVisibilityOff /> : <MdVisibility />}
                    </IconButton>
                  </InputAdornment>
                }
              />
              <Button
                onClick={() => {
                  dispatch(showAuthLoader());
                  dispatch(userSignIn({ email, password }));
                }}
                variant="contained"
                color="primary"
                fullWidth
              >
                <IntlMessages id="appModule.signIn" />
              </Button>
              <div className="login-actions">
                <a
                  href="https://www.linkedin.com/company/intelnova-intelapp-intelcare/?viewAsMember=true"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src="/media/login/linkedIn.png" alt="LinkedIn" />
                </a>
                <a
                  href="https://www.facebook.com/people/Intelnova-Healthtech/pfbid02bNhJnGxcRmQWELhR4awyFkx9VTc5VADUM9uUEjaGGV9oSFbxDMTeSKyjs5Bpm724l/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src="/media/login/facebook.png" alt="Facebook" />
                </a>
                <a
                  href="https://intelnova.co/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src="/media/login/sitioWeb.png" alt="Sitio Web" />
                </a>
              </div>
              <div className="login-bottom-image">
                <img
                  src="/media/login/iconoIntelnova.png"
                  alt="IntelNova"
                />
              </div>
            </fieldset>
          </form>
        </div>
      </div>
      {loader && (
        <div className="loader-view">
          <CircularProgress />
        </div>
      )}
      {showMessage &&
        NotificationManager.error(
          alertMessage === "401" ? msgLoginInvalid : alertMessage
        )}
    </div>
  );
};

export default SignIn;
